<script>
	// import { applyStyleFix } from '@/utils/style-fix.js'

	export default {
		onLaunch: function() {
			console.log('App Launch')

			// #ifdef H5
			// 检测短链接跳转（在App级别处理更可靠）
			this.handleShortLink()

			// 检测是否在<-WE_CODE>
			if (this.isWechatH5()) {
				console.log('微信H5环境，加载兼容性样式')
				this.loadWechatH5Fix()
			}

			// 应用样式修复（解决线上与线下样式不一致问题）- 暂时禁用，需要时再开启
			// this.$nextTick(() => {
			// 	applyStyleFix()
			// })
			// #endif
		},
		
		onShow: function() {
			console.log('App Show')
		},
		onHide: function() {
			console.log('App Hide')
		},
		
		methods: {
			// #ifdef H5
			/**
			 * @description 处理短链接跳转
			 */
			handleShortLink() {
				const path = window.location.pathname
				const hash = window.location.hash
				
				console.log('App Launch - 路径检测:', { path, hash })
				
				// 如果已经有hash路由，不处理
				if (hash && hash.includes('#/')) {
					console.log('已有hash路由，跳过短链接处理')
					return
				}
				
				// 检测短链接格式 /XXXXXX
				if (path && path.length > 1 && path !== '/') {
					const code = path.substring(1)
					// 匹配防丢码格式（字母+数字，不区分大小写）
					if (/^[A-Za-z0-9]+$/.test(code)) {
						console.log('检测到防丢码短链接:', code)
						// 保存到storage，让首页处理
						uni.setStorageSync('short_link_code', code)
					}
				}
			},
			// #endif
			
			/**
			 * @description 检测是否在<-WE_CODE>
			 */
			isWechatH5() {
				// #ifdef H5
				const ua = navigator.userAgent.toLowerCase()
				return ua.indexOf('micromessenger') !== -1
				// #endif
				return false
			},
			/**
			 * @description 加载微信H5修复样式
			 */
			loadWechatH5Fix() {
				// #ifdef H5
				if (!document.getElementById('wechat-h5-fix')) {
					const link = document.createElement('link')
					link.id = 'wechat-h5-fix'
					link.rel = 'stylesheet'
					link.href = '/static/wechat-h5-fix.css'
					document.head.appendChild(link)
					console.log('微信H5修复样式已加载')
				}
				// #endif
			}
		}
	}
</script>

<style>
	/*每个页面公共css */
	
	/* 引入线上环境样式修复 */
	@import './styles/production-fix.css';
	
	/* ==================== 全局基础样式 ==================== */
	/* 这些样式确保线上环境与开发环境一致 */
	
	page {
		font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
		line-height: 1.5;
		color: #333;
	}
	
	/* ==================== 表单组件全局样式修复 ==================== */
	
	/* uni-forms 全局修复 */
	uni-forms-item {
		display: flex;
		flex-direction: column;
		margin-bottom: 16px;
		line-height: 1.5;
	}
	
	uni-forms-item__label {
		display: flex;
		align-items: center;
		min-height: 32px;
		font-size: 14px;
		color: #333;
		margin-bottom: 8px;
		line-height: 1.5;
	}
	
	uni-forms-item__content {
		display: flex;
		flex-direction: column;
		min-height: 40px;
		line-height: 1.5;
	}
	
	/* uni-easyinput 全局修复 - 使用 !important 确保线上环境生效 */
	uni-easyinput,
	.uni-easyinput {
		display: block !important;
		width: 100% !important;
		line-height: 1.5 !important;
		visibility: visible !important;
		opacity: 1 !important;
	}
	
	uni-easyinput__content,
	.uni-easyinput__content {
		display: flex !important;
		align-items: center !important;
		min-height: 40px !important;
		height: 40px !important;
		background: #f5f5f5 !important;
		border-radius: 4px !important;
		padding: 0 12px !important;
		line-height: 40px !important;
		box-sizing: border-box !important;
		visibility: visible !important;
		opacity: 1 !important;
	}
	
	uni-easyinput__content-input,
	.uni-easyinput__content-input {
		display: block !important;
		flex: 1 !important;
		width: 100% !important;
		height: 40px !important;
		min-height: 40px !important;
		max-height: 40px !important;
		line-height: 40px !important;
		font-size: 14px !important;
		color: #333 !important;
		background: transparent !important;
		border: none !important;
		outline: none !important;
		padding: 0 !important;
		margin: 0 !important;
		-webkit-appearance: none !important;
		appearance: none !important;
		visibility: visible !important;
		opacity: 1 !important;
	}
	
	/* picker 全局修复 */
	uni-picker {
		display: block;
		width: 100%;
	}
	
	/* ==================== 强制全局输入框样式 ==================== */
	/* 这些样式会被打包到 CSS 文件中 */
	
	/* 基础输入框样式 */
	input[type="text"],
	input[type="number"],
	input[type="email"],
	input[type="password"],
	textarea {
		font-size: 14px;
		-webkit-appearance: none;
		appearance: none;
		outline: none;
		border: 1px solid #ddd;
		background: #fff;
		padding: 8px 12px;
		border-radius: 4px;
	}
	
	/* 微信H5快速检测样式 */
	@media screen and (-webkit-min-device-pixel-ratio: 0) {
		input, textarea, .uni-input, .uni-textarea {
			-webkit-appearance: none;
			appearance: none;
		}
	}
	
	/* uni-view 修复 */
	uni-view {
		display: block;
		box-sizing: border-box;
	}
	
	/* ==================== uni-easyinput 样式定义 ==================== */
	/* 线上构建时需要这些样式 */
	.uni-easyinput {
		display: flex;
		flex-direction: column;
		width: 100%;
	}
	
	.uni-easyinput__content {
		display: flex;
		flex-direction: row;
		align-items: center;
		min-height: 36px;
		background-color: #f5f5f5;
		border-radius: 4px;
		padding: 0 12px;
		box-sizing: border-box;
	}
	
	.uni-easyinput__content-input {
		flex: 1;
		width: 100%;
		height: 36px;
		min-height: 36px;
		line-height: 36px;
		font-size: 14px;
		color: #333;
		background: transparent;
		border: none;
		outline: none;
		padding: 0;
		margin: 0;
		-webkit-appearance: none;
		appearance: none;
		pointer-events: auto;
		user-select: text;
		cursor: text;
	}
	
	/* 禁用状态 */
	.uni-easyinput--disabled .uni-easyinput__content {
		background-color: #e8e8e8;
	}
	
	.uni-easyinput--disabled .uni-easyinput__content-input {
		color: #999;
		cursor: not-allowed;
	}
	
	/* Placeholder 样式 */
	.uni-easyinput__content-input::placeholder {
		color: #999;
	}
	
	/* ==================== uni-forms 样式定义 ==================== */
	.uni-forms-item {
		display: flex;
		flex-direction: column;
		margin-bottom: 16px;
	}
	
	.uni-forms-item__label {
		display: flex;
		align-items: center;
		height: 32px;
		font-size: 14px;
		color: #333;
		margin-bottom: 4px;
	}
	
	.uni-forms-item__content {
		display: flex;
		flex-direction: column;
	}
	
	/* ==================== uni-data-select 样式定义 ==================== */
	.uni-data-select {
		display: flex;
		flex-direction: column;
		width: 100%;
	}
	
	.uni-data-select__input-box {
		display: flex;
		align-items: center;
		min-height: 36px;
		background-color: #f5f5f5;
		border-radius: 4px;
		padding: 0 12px;
		box-sizing: border-box;
	}
	
	.uni-data-select__input-text {
		flex: 1;
		font-size: 14px;
		color: #333;
	}
</style>
